module.exports = __webpack_public_path__ + "static/media/leaf-right.a160d4a6.png";